// extracted by mini-css-extract-plugin
module.exports = {"title":"Title_title__MZ67h","headline":"Title_headline__ztVQY","title-uc-xxxxl":"Title_title-uc-xxxxl__LZoh9"};